// The runs feature (web-runs, p1h-web-5c): a project's runs and their live pages, in the Work
// group, and a "Runs" tab on agents.
import { ActivityIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { registerKindTab } from "../../kinds/tabs";
import { routes } from "../context";
import { AgentRunsTab } from "./agent-runs-tab";

registerNav({
  id: "runs",
  group: "work",
  labelKey: "runs.nav",
  icon: ActivityIcon,
  to: ({ params, search }) => {
    const project =
      params.project ?? (typeof search.project === "string" ? search.project : undefined);
    return params.workspace && project ? routes.runs(params.workspace, project) : null;
  },
  order: 20,
});

registerKindTab({
  kind: "Agent",
  id: "runs",
  labelKey: "runs.tab",
  order: 10,
  panel: AgentRunsTab,
});
